import { render, staticRenderFns } from "./PromotionStepGeneralInfo.vue?vue&type=template&id=119a05b8&scoped=true&"
import script from "./PromotionStepGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./PromotionStepGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./PromotionStepGeneralInfo.vue?vue&type=style&index=0&id=119a05b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a05b8",
  null
  
)

export default component.exports